export default __webpack_public_path__ + "static/media/Aura-Egg__88.d29553e9.png";